import { CustomFormQueryTypes } from 'src/app/custom-form-builder/enums/custom-form-query-types.enum';
import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const CustomFormBuilderLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    customForms: LazyLoadedStates,
    usageReport: LazyLoadedStates,
    builder: LazyLoadedStates,
    edit: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.custom-form-builder',
        url: '/custom-form-builder',
        abstract: true
    },
    customForms: {
        name: 'authenticated.custom-form-builder.custom-forms',
        url: '/custom-forms/:page?limit&searchBy&orderBy&ascending&type',
        params: {
            page: {
                raw: true,
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                type: 'int',
                value: 10
            },
            searchBy: {
                raw: true,
                type: 'string',
                value: '',
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            },
            type: {
                raw: true,
                type: 'int',
                value: CustomFormQueryTypes.ACTIVE_DRAFT
            }
        },
    },
    usageReport: {
        name: 'authenticated.custom-form-builder.usage-report',
        url: '/usage-report/:formId/:page?limit&searchBy&orderBy&ascending',
        params: {
            formId: {
                raw: true,
                type: 'string'
            },
            page: {
                raw: true,
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                type: 'int',
                value: 10
            },
            searchBy: {
                raw: true,
                type: 'string',
                value: '',
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        },
    },
    builder: {
        name: 'authenticated.custom-form-builder.builder',
        url: '/builder',
        abstract: true
    },
    edit: {
        name: 'authenticated.custom-form-builder.builder.edit',
        url: '/edit/:formId?tabIndex',
        params: {
            formId: {
                raw: true,
                type: 'string'
            },
            tabIndex: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: 1
            }
        }
    },
},
() => import('src/app/custom-form-builder/custom-form-builder.module').then((result: {CustomFormBuilderModule: any}) => result.CustomFormBuilderModule)
);
